
  import {
    defineComponent,
    ref,
    onMounted,
    computed,
    onBeforeUnmount,
  } from 'vue';
  import { useRouter } from 'vue-router';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Datatable from '@/components/kt-datatable/KTDatatable.vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';

  export default defineComponent({
    name: 'subscription-users-listing',
    components: {
      Datatable,
    },
    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const { can } = useAbility();

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      onMounted(() => {
        setCurrentPageBreadcrumbs(translate('usersListing'), [
          translate('members'),
        ]);
      });

      onBeforeUnmount(() => {
        store.dispatch(Actions.RESET_USERS_SUBSCRIPTION_STORE);
      });

      await store.dispatch(Actions.GET_USERS_SUBSCRIPTIONS);
      const loading = ref(false);
      const tableHeader = ref([
        {
          name: translate('id'),
          key: 'id',
          sortable: true,
        },
        {
          name: translate('name'),
          key: 'memberName',
          sortable: true,
        },
        {
          name: translate('phoneNumber'),
          key: 'memberPhone',
          sortable: true,
        },
        {
          name: translate('subscription'),
          key: 'subscriptionTitle',
          sortable: true,
        },
        {
          name: translate('subscriptionType'),
          key: 'subscriptionSlug',
          sortable: true,
        },
        {
          name: translate('endDate'),
          key: 'endDate',
          sortable: true,
        },
        {
          name: translate('isActive'),
          key: 'isActive',
          sortable: false,
        },
        {
          name: translate('renew'),
          key: 'renew',
          sortable: false,
        },
        {
          name: translate('oneTime'),
          key: 'oneTime',
          sortable: false,
        },
        {
          name: translate(''),
          key: 's',
          sortable: false,
        },
      ]);
      // const toggleStatusUser = async (user) => {
      //   const deletedMessage = user.isActive
      //     ? 'confirmInActive'
      //     : 'confirmActive';
      //   const result = await Swal.fire({
      //     title: translate('areYouSureQ'),
      //     icon: 'warning',
      //     text: translate(deletedMessage),
      //     showCancelButton: true,
      //     buttonsStyling: false,
      //     confirmButtonText: translate('confirm'),
      //     cancelButtonText: translate('cancel'),
      //     customClass: {
      //       confirmButton: 'btn fw-bold btn-warning',
      //       cancelButton: 'btn btn-light',
      //     },
      //   });

      //   if (result.value) {
      //     loading.value = true;
      //     await store.dispatch(Actions.UPDATE_USER, user.id);
      //     await store.dispatch(Actions.GET_USERS);
      //     loading.value = false;
      //     const [errorName] = Object.keys(store.getters.getErrors);
      //     const error = store.getters.getErrors[errorName];
      //     if (error) {
      //       Swal.fire({
      //         text: translate(error[0]),
      //         icon: 'error',
      //         buttonsStyling: false,
      //         confirmButtonText: translate('tryAgainExcl'),
      //         customClass: {
      //           confirmButton: 'btn fw-bold btn-light-danger',
      //         },
      //       });
      //     } else {
      //       const successMsg = user.isActive
      //         ? 'SUCCESSFULLY_INACTIVATED'
      //         : 'SUCCESSFULLY_ACTIVEATED';
      //       Swal.fire({
      //         text: translate(successMsg),
      //         icon: 'success',
      //         buttonsStyling: false,
      //         confirmButtonText: translate('ok'),
      //         customClass: {
      //           confirmButton: 'btn btn-light-primary',
      //         },
      //       });
      //     }
      //   }
      // };

      const goTo = (pageName) => {
        router.push({ name: pageName });
      };

      const pageChanged = async (val) => {
        loading.value = true;
        await store.dispatch(
          Actions.UPDATE_USERS_SUBSCRIPTIONS_CURRENT_PAGE,
          val
        );
        await store.dispatch(Actions.GET_USERS_SUBSCRIPTIONS);
        loading.value = false;
      };

      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');

      return {
        tableData: computed(() => store.getters.usersubscriptionsList),
        tableHeader,
        translate,
        totalItems: computed(() => store.getters.usersubscriptionsListCount),
        pageChanged,
        goTo,
        loading,
        can,
      };
    },
  });
